import React from "react"

const Kartikey = () => {
  return (
    <div>
      kartikey
    </div>
  )
};

export default Kartikey
